import React, { forwardRef } from "react";

import { RadioButtonGroupItem } from "./radio-button-group-item";
import type { RadioButtonGroupRootProps } from "./radio-button-group-root";
import { RadioButtonGroupRoot } from "./radio-button-group-root";

export {
  RADIO_BUTTON_GROUP_DIRECTION,
  RADIO_BUTTON_GROUP_ORIENTATION,
  type RadioButtonGroupDirection,
  type RadioButtonGroupOrientation,
} from "./constants";

type RadioButtonGroupCmp = React.ForwardRefExoticComponent<
  RadioButtonGroupProps & React.RefAttributes<HTMLDivElement>
> & {
  Item: typeof RadioButtonGroupItem;
};

export type RadioButtonGroupProps = RadioButtonGroupRootProps;

export const RadioButtonGroup = forwardRef<HTMLDivElement, RadioButtonGroupProps>(
  ({ children, ...props }, ref) => (
    <RadioButtonGroupRoot ref={ref} {...props}>
      {children}
    </RadioButtonGroupRoot>
  )
) as RadioButtonGroupCmp;

RadioButtonGroup.Item = RadioButtonGroupItem;

RadioButtonGroup.displayName = "RadioButtonGroup";
